import * as React from 'react';
export default function SvgPaperclip() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.951l-6.116 5.91c-1.918 1.852-5.028 1.852-6.946 0a4.632 4.632 0 01.018-6.729L8.36 9.075m0 0l.493-.471m-.493.47l3.491-3.372c1.313-1.268 3.44-1.268 4.752 0a3.17 3.17 0 01-.012 4.603l-3.238 3.095M8.36 9.075l-.417.403m5.41 3.922l.367-.354m-.367.354l-2.47 2.387a1.86 1.86 0 01-2.565 0 1.711 1.711 0 010-2.479l4.727-4.566",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}